import React, { useState } from "react";
import mediaImage from "../assets/images/piston5E.jpg";
import { trackClickEvent } from "../utils/analytics";
import GlobalFooter from "../components/GlobalFooter";

export default function ContactSection() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    trackClickEvent("Contact", "Form Submitted");

    await fetch("https://formspree.io/f/your-form-id", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    });

    setIsSubmitted(true);
    e.target.reset();
  };

  return (
    <>
      <section className="relative bg-black text-white overflow-hidden min-h-screen">
        {/* Static Image */}
        <img
          src={mediaImage}
          alt="Contact Background"
          className="absolute inset-0 w-full h-full object-cover opacity-50 z-0"
        />

        {/* Frosted Glass Overlay */}
        <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8 pt-32 pb-20">
          <div className="bg-white/20 backdrop-blur-lg rounded-2xl p-6 md:p-8 shadow-xl border border-white/10 w-full">
            <div className="text-center">
              <h2 className="text-3xl font-bold mb-4">LET'S MAKE IT FLY</h2>
              <p className="text-base text-white/80 mb-6">
                Ready to move an aircraft? Need a shoot that sells? Use the form below — we’ll handle the rest.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="grid md:grid-cols-2 gap-6">
              {/* Left column */}
              <div className="space-y-5">
                <div>
                  <label className="block font-medium mb-1">Name</label>
                  <input
                    name="name"
                    required
                    className="w-full bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-md placeholder:text-white/60 border border-white/20"
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">Email</label>
                  <input
                    name="email"
                    type="email"
                    required
                    className="w-full bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-md placeholder:text-white/60 border border-white/20"
                    placeholder="you@example.com"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">Phone (optional)</label>
                  <input
                    name="phone"
                    className="w-full bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-md placeholder:text-white/60 border border-white/20"
                    placeholder="(555) 555-5555"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">Preferred Contact Method</label>
                  <select
                    name="preferredContact"
                    className="w-full bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-md border border-white/20"
                  >
                    <option value="">Select a method</option>
                    <option value="Email">Email</option>
                    <option value="Phone">Phone</option>
                    <option value="Text">Text</option>
                  </select>
                </div>

                <div>
                  <label className="block font-medium mb-1">What service do you need?</label>
                  <select
                    name="service"
                    required
                    className="w-full bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-md border border-white/20"
                  >
                    <option value="">Select a service</option>
                    <option value="Aircraft Photography">Aircraft Photography</option>
                    <option value="Ferry Flight">Ferry Flight</option>
                    <option value="Pilot Day Rate">Pilot Day Rate</option>
                    <option value="Consulting">Pre-sale Audit & Consulting</option>
                  </select>
                </div>
              </div>

              {/* Right column */}
              <div className="space-y-5 flex flex-col justify-between">
                <div>
                  <label className="block font-medium mb-1">Aircraft Type & Location</label>
                  <input
                    name="aircraft"
                    className="w-full bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-md border border-white/20"
                    placeholder="e.g. Cirrus SR22 — Orlando, FL"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">Message or Notes</label>
                  <textarea
                    name="message"
                    rows="6"
                    className="w-full bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-md border border-white/20"
                    placeholder="Include dates, urgency, or context here..."
                  />
                </div>

                {isSubmitted && (
                  <p className="text-green-400 font-medium">Submitted — we'll be in touch shortly.</p>
                )}

                <div>
                  <button
                    type="submit"
                    onClick={() => trackClickEvent("Contact", "Clicked: Send Request")}
                    className="w-full py-2 rounded-full bg-white/10 hover:bg-white/20 text-white font-semibold border border-white/20 transition"
                  >
                    Send Request
                  </button>
                  <p className="text-sm text-white/60 mt-4">
                    You’re not submitting a form to nowhere. Every form goes straight to the Strobe inbox. We’ll review it and reach out personally — usually same day.
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* ✅ Correctly placed Global Footer */}
      <GlobalFooter />
    </>
  );
}
